export const AppleIcon = () => (
  <svg viewBox="0 0 24 24" className="h-6 w-6" fill="currentColor" aria-hidden="true"><path d="M16.37 12.6c-.02-2.3 1.88-3.4 1.97-3.46-1.07-1.57-2.74-1.78-3.33-1.8-1.42-.14-2.77.83-3.49.83-.72 0-1.83-.81-3.01-.79-1.55.02-2.98.9-3.78 2.29-1.61 2.8-.41 6.94 1.16 9.21.77 1.11 1.68 2.36 2.88 2.31 1.16-.05 1.59-.75 2.99-.75 1.4 0 1.79.75 3.01.72 1.24-.02 2.03-1.13 2.79-2.25.88-1.29 1.24-2.53 1.26-2.6-.03-.01-2.42-.93-2.45-3.71zM14.08 5.85c.64-.77 1.07-1.85.95-2.92-.92.04-2.03.61-2.69 1.38-.59.68-1.11 1.78-.97 2.83 1.02.08 2.07-.52 2.71-1.29z" /></svg>
);
export const PlayIcon = () => (
  <svg viewBox="0 0 24 24" className="h-5 w-5" aria-hidden="true"><path fill="#34A853" d="M3.6 1.8 13.4 12 3.6 22.2c-.4-.2-.6-.6-.6-1.1V2.9c0-.5.2-.9.6-1.1z" /><path fill="#FBBC04" d="m16.7 15.3-3.3-3.3 3.3-3.3 3.8 2.2c1.1.6 1.1 1.6 0 2.2z" /><path fill="#EA4335" d="M13.4 12 3.6 22.2c.4.2.9.2 1.4-.1l11.7-6.8z" /><path fill="#4285F4" d="M13.4 12 16.7 8.7 5 1.9c-.5-.3-1-.3-1.4-.1z" /></svg>
);

const Badge = ({ href, icon, top, label, testId, dark }) => {
  const base = `inline-flex min-w-[170px] items-center gap-3 rounded-xl px-4 py-2.5 ${dark ? "bg-white text-[#0B132B]" : "bg-[#0B132B] text-white"}`;
  const inner = (
    <>
      {icon}
      <span className="leading-tight">
        <span className="block text-[10px] font-medium uppercase tracking-wide opacity-80">{href ? top : "Coming soon to"}</span>
        <span className="block text-base font-bold">{label}</span>
      </span>
    </>
  );
  return href ? (
    <a href={href} target="_blank" rel="noopener noreferrer" data-testid={testId} className={`${base} transition-transform duration-300 hover:-translate-y-0.5`}>{inner}</a>
  ) : (
    <span data-testid={testId} aria-disabled="true" title="Coming soon" className={`${base} cursor-not-allowed opacity-45`}>{inner}</span>
  );
};

export const StoreButtons = ({ app, dark = false }) => (
  <div className="flex flex-wrap gap-3">
    <Badge href={app.appStore} icon={<AppleIcon />} top="Download on the" label="App Store" testId={`appstore-btn-${app.id}`} dark={dark} />
    <Badge href={app.playStore} icon={<PlayIcon />} top="Get it on" label="Google Play" testId={`playstore-btn-${app.id}`} dark={dark} />
  </div>
);
